import React from 'react';
import BaseSelector, { SelectOption, SelectProps } from '@/components/selectors/BaseSelector';
import { StatusTag, TagState } from '@/components/shared/Tags.tsx';

export interface TagSelectorProps extends SelectProps {
    getTagState: (item: SelectOption) => TagState;
}

const TagSelector: React.FC<TagSelectorProps> = ({
    getTagState,
    itemText = 'text',
    itemValue = 'value',
    className,
    ...rest
}) => {
    const renderTag = (item: SelectOption) => <StatusTag state={getTagState(item)} label={item[itemText]} />;

    return (
        <BaseSelector
            {...rest}
            itemText={itemText}
            itemValue={itemValue}
            className={['tag-selector', className].filter(Boolean).join(' ')}
            renderSelectedValue={renderTag}
            renderOption={renderTag}
        />
    );
};

export default TagSelector;
